/*=========================================================================================
  File Name: index.js
  Description: Vuex store
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import appStore from './app.store'
import themeStore from './theme'
import courseStore from './course'
import userStore from './user'
import videoStore from './video'
import quizStore from './quiz'
import instructorStore from './instructors.store'
import vendorStore from './vendors.store'
import categoryStore from './categories.store'
import lareaStore from './lareas.store'
import passStore from './pass'
import lpathStore from './learningpath'
import exerciseStore from './exercise'
import labStore from './lab'
import fileStore from './file'
import iframeStore from './iframe'
import ratingStore from './ratings.store'
import collectionStore from './collection'
import reportingStore from './reporting'
import sonarStore from './sonar'
import sonarlareasStore from './sonarlareas.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app: appStore,
    courses: courseStore,
    users: userStore,
    videos: videoStore,
    quizzes: quizStore,
    instructors: instructorStore,
    vendors: vendorStore,
    categories: categoryStore,
    lareas: lareaStore,
    passes: passStore,
    lpaths: lpathStore,
    exercises: exerciseStore,
    labs: labStore,
    files: fileStore,
    iframes: iframeStore,
    ratings: ratingStore,
    collections: collectionStore,
    reporting: reportingStore,
    sonar: sonarStore,
    sonarlareas: sonarlareasStore
  },
  ...themeStore,
  strict: process.env.NODE_ENV !== 'production'
})
